define('models/base/baseModel',[
    'backbone',
    'underscore',
    'mixins/backbone/syncEvent'
],
function (Backbone, _, syncMixin) {
    'use strict';
    return Backbone.Model.extend(_.extend(syncMixin));
});
